require('impress-js-recompute');
const _ = require('lodash');
const TrackingService = require('./TrackingService');
const SignUpService = require('../../../form/components/signup/SignUpService');

function ImpressService() {

    var onEnterListeners = [];
    var onLeaveListeners = [];
    var rootElement = document;

    var previousSlide, currentSlide;

    var loaded, impressApi;

    this.init = () => {
        if(loaded){
            console.warn("Impress already loaded");
            return;
        }
        loaded = true;
        impressApi = impress();
        impressApi.init();

        this.prev = impressApi.prev.bind(impressApi);
        this.next = impressApi.next.bind(impressApi);
        this.start = impressApi.goto.bind(impressApi, 0);
        this.end = impressApi.goto.bind(impressApi, getAllSlides().length - 1);

        // disabled default key bindings
        impressApi.prev = _.noop;
        impressApi.next = _.noop;

        return impressApi;
    };

    this.resetSteps = () => {
        impressApi.recompute();
    };

    this.start = this.end = this.next = this.prev = _.noop;

    this.onLeave = function (from, listener) {
        var item = {
            from,
            to : undefined,
            listener
        };
        onLeaveListeners.push(item);
        return removeListener.bind(this, onLeaveListeners, item);
    };

    this.onLeaveTo = function (to, from, listener) {
        var item = {
            from,
            to,
            listener
        };
        onLeaveListeners.push(item);
        return removeListener.bind(this, onLeaveListeners, item);
    };

    this.onEnter = function (to, listener) {
        var item = {
            to,
            from : undefined,
            listener
        };
        onEnterListeners.push(item);
        return removeListener.bind(this, onEnterListeners, item);
    };

    this.onEnterFrom = function (to, from, listener) {
        var item = {
            from,
            to,
            listener
        };
        onEnterListeners.push(item);
        return removeListener.bind(this, onEnterListeners, item);
    };

    function removeListener(listeners, listener) {
        var index = listeners.indexOf(listener);
        return index !== -1 ? _.first(listeners.splice(index, 1)) : [];
    }

    rootElement.addEventListener("impress:stepenter", (event) => {
        trigger(onEnterListeners, event);
        trackNavigate(currentSlide);
    });

    rootElement.addEventListener("impress:stepleave", trigger.bind(this, onLeaveListeners));

    function trigger(listeners, event) {
        previousSlide = event.type === 'impress:stepleave' ? currentSlide : previousSlide;
        currentSlide = document.querySelector(".slide.active").id;
        var matchesCurrentAndLast = _.conforms({
            to : equalsOrUndefined.bind(this, currentSlide),
            from : equalsOrUndefined.bind(this, previousSlide)
        });
        listeners.filter(matchesCurrentAndLast).forEach(run);
    }

    function run(item) {
        var allSlides = getAllSlides();
        item.listener(currentSlide, previousSlide, allSlides);
    }

    function equalsOrUndefined(slide, slideSelected) {
        return slide === slideSelected || slideSelected === void(0);
    }

    function getAllSlides() {
        return _.map(document.querySelectorAll('.step.slide'), 'id');
    }

    function trackNavigate(slide) {
        const data = {
            slide
        };
        SignUpService.getCurrentUser()
            .then((user) => {
                if (user) {
                    data.user = _.get(user, 'username');
                }
            })
            .catch(console.log)
            .then(() => {
                TrackingService.trackEvent('navigate', data);
            });
    }
}

module.exports = new ImpressService();


//////////////////
// WEBPACK FOOTER
// ./src/js/services/ImpressService.js
// module id = 8
// module chunks = 0